const getTotalWeight = (assignments) =>
  assignments.reduce((total, { weightage }) => {
    if (Number.isInteger(weightage)) {
      return total + weightage;
    }

    return total;
  }, 0);

export default getTotalWeight;
